import { render, staticRenderFns } from "./RowItem.vue?vue&type=template&id=6d2c389d&scoped=true&"
import script from "./RowItem.vue?vue&type=script&lang=js&"
export * from "./RowItem.vue?vue&type=script&lang=js&"
import style0 from "./RowItem.vue?vue&type=style&index=0&id=6d2c389d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d2c389d",
  null
  
)

export default component.exports